import { useEffect, useState } from 'react';
import { useRequestsHandlerData } from '../../../useRequestsHandlerData';
import { useApplicationCallbacks } from '../../../../providers/application-callbacks';
import { rating as ratingData } from '../../../../constants/copyright';

const { ratingCount, ratingPromises } = ratingData;

export default function useRatingInfo() {
  const [rating, setRating] = useState({ ratingMonth: [], ratingWeek: [], ratingUserMonth: [], ratingUserWeek: [] });
  const [range, setRange] = useState('week');
  const callbacks = useApplicationCallbacks();

  const ratingInfo = (() => {
    const { ratingMonth, ratingWeek, ratingUserMonth, ratingUserWeek } = rating;

    const rangeLogic = {
      month: {
        user: ratingUserMonth,
        rating: ratingMonth?.rating ?? ratingMonth,
        date: ratingMonth?.startDate && `${ratingMonth?.startDate}-${ratingMonth?.endDate}`,
      },
      week: {
        user: ratingUserWeek,
        rating: ratingWeek?.rating ?? ratingWeek,
        date: ratingWeek?.startDate && `${ratingWeek?.startDate}-${ratingWeek?.endDate}`,
      },
    };

    const activeRatings = rangeLogic[range];

    const isInsideRating =
      activeRatings?.rating?.find?.(({ uid }) => activeRatings?.user?.uid === uid)?.position > ratingCount;

    return { activeRatings, isInsideRating };
  })();

  const currentRangeRequests = ratingPromises.filter((request) => request.type === range);

  const isRatingPending = useRequestsHandlerData(
    currentRangeRequests.map(({ address, field, key }) => ({
      address,
      fulfilled(data) {
        if (!Array.isArray(field)) {
          setRating((prev) => ({ ...prev, [key]: data[field] }));
          return;
        }
        setRating((prev) => ({
          ...prev,
          [key]: field.reduce((acc, item) => ({ ...acc, [item]: data[item] }), {}),
        }));
      },
    })),
  );

  useEffect(() => {
    if (range === 'week' && !rating.ratingWeek?.rating?.length && !rating.ratingUserWeek?.uid) {
      callbacks.getGeneralWeekRating();
    }

    if (range === 'month' && !rating.ratingMonth?.length && !rating.ratingUserMonth?.uid) {
      callbacks.getGeneralMonthRating();
    }
  }, [range, rating]);

  return {
    isRatingPending,
    ratingInfo,
    range: { range, setRange },
  };
}
